import request from '../../request'
import {checkin} from '../../endpoints'

export default class checkinApi {
  static async get(matId, schoolId) {
    return request({
      url: checkin.get(matId, schoolId),
      method: 'GET',
    })
  }
  static async getAll() {
    return request({
      url: checkin.getAll(),
      method: 'GET',
    })
  }
  static async getTemplateQuestions(id) {
    return request({
      url: checkin.templateQuestions(id),
      method: 'GET',
    })
  }

  static async post(data) {
    return request({
      url: checkin.post(),
      method: 'POST',
      data: JSON.stringify(data),
    })
  }
  static async getList(id) {
    return request({
      url: checkin.getList(id),
      method: 'GET',
    })
  }
  static async getListDetail(id) {
    return request({
      url: checkin.getListDetail(id),
      method: 'GET',
    })
  }
  static async getById(id) {
    return request({
      url: checkin.getById(id),
      method: 'GET',
    })
  }
  static async pause(id) {
    return request({
      url: checkin.pause(id),
      method: 'POST',
    })
  }
  static async resume(id) {
    return request({
      url: checkin.resume(id),
      method: 'POST',
    })
  }
  static async stop(id) {
    return request({
      url: checkin.stop(id),
      method: 'POST',
    })
  }
  static async getParticipationBySchool(id) {
    return request({
      url: checkin.participationBySchool(id),
      method: 'GET',
    })
  }
  static async getInviteReadiness(filter) {
    return request({
      url: checkin.inviteReadiness(),
      method: 'POST',
      data: JSON.stringify(filter),
    })
  }
}
